import React, { FC, useState } from 'react';
import Modal from '../../common/Modal';
import Text from '../../common/Text';
import Button from '../../common/Button';
import parse from 'html-react-parser';

interface RXC_CRASH_POPUP_TYPE {
  errorTitle?: string;
  errorDescription?: string;
  buttonLabel?: string;
}

const RXC_CRASH_POPUP: FC<RXC_CRASH_POPUP_TYPE> = ({
  errorTitle = 'Something went wrong...',
  errorDescription = "We’re experiencing some technical difficulties, we apologize. In the meantime, if you have any questions or need assistance, feel free to <a href='#'>contact our customer service.</a>",
  buttonLabel = 'Back',
}) => {
  const [open, setOpen] = useState(true);
  const closeRXC = () => {
    setOpen(false);
    setTimeout(() => {
      window.RXC.rxcWidget.close('#rxcApp');
    }, 0);
    window.dispatchEvent(new CustomEvent('BackToPdp'));
  };

  if (!open) return null;

  return (
    <>
      <div id="headlessui-portal-root">
        <div id="headlessui-crash-portal"></div>
      </div>
      <Modal onClose={closeRXC} isCrashPopup>
        <div
          aria-labelledby="modal-title"
          className="RXC_CRASH_POPUP tw-flex tw-flex-col tw-items-center tw-gap-4"
        >
          <Text
            as="h2"
            align="center"
            size="2xl"
            className="tw-font-BaseTextDark tw-mb-4"
            id="modal-title"
          >
            {errorTitle}
          </Text>
          <Text
            as="p"
            weight="normal"
            align="center"
            size="sm"
            className="tw-mb-4 tw-max-w-2xl"
          >
            {parse(errorDescription)}
          </Text>
          <Button onClick={closeRXC} className="tw-w-max">
            {buttonLabel}
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default RXC_CRASH_POPUP;
